import { SiteTypes } from '../enums';
import { getEndpointURL } from './getEndpointUrl';

export const goToBag = () => {
  window.location.href = getEndpointURL(SiteTypes.CART);
};
